import { render } from "./CheckBoxesType.vue?vue&type=template&id=0158c336"
import script from "./CheckBoxesType.vue?vue&type=script&lang=js"
export * from "./CheckBoxesType.vue?vue&type=script&lang=js"

import exportComponent from "/opt/approot/build.20261030-093834-708061d9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__